var symphony = symphony || {};

;(function() {

	symphony.getLocalNews = function() {

		if($('#newsIndex').length <= 0){
			return;
		}
		
		$('body').addClass('loading');

		var url = '/' + siteUrlAlias;
		if (typeof symphony.admin != 'undefined') {
			url += '/admin'
		}

		var getLocalDocsPromise = $.get(url + '/news/symphony/json/all/true/0/999?random=' + new Date().getUTCMilliseconds(), function(data){
			var response = JSON.parse(unescape(decodeURI(data)).replace(/\+/g,' '));//data;//JSON.parse(data);
			var news = $.grep(response.news, function(r, i) { return r.published; });
			news = _.sortBy(news, function(x){ return (x.publishDate != null ? x.publishDate : x.modified); }).reverse();
			$('#newsIndex').empty().append(symphony.templates.newsIndex({news:news}));

			$('body').removeClass('loading');
		},
		'text');
	}

})();